'use client'

import type { ForwardedRef, TextareaHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { cn } from '../lib/utils.ts'

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>

/**
 * Multi-line counterpart to `Input` — same border, focus ring, disabled and
 * `aria-invalid` treatment, so a textarea never looks foreign next to the
 * single-line fields in the same form.
 */
export const Textarea = forwardRef(function Textarea(
  { className, ...props }: TextareaProps,
  ref: ForwardedRef<HTMLTextAreaElement>,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'ring-offset-background flex min-h-20 w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
        className,
      )}
      {...props}
    />
  )
})

Textarea.displayName = 'Textarea'
